export default "__VITE_ASSET__sidtv4Dq__"